module.exports = __webpack_public_path__ + "img/gricon1.8ee0e76a.png";